import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Form.module.scss'

import { Form, Image, Modal } from 'react-bootstrap'

import { IMaskInput } from 'react-imask'

import GreenButton from './GreenButton'

import axios from 'axios'

class SimleForm extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      phone: ``,
      name: ``,
      show_msg: false,
      modal_body: ``,
      isSending: false
    }
  }

  changePhone( phone ) {
    this.setState({
      phone: phone
    })
  }

  changeName( name ) {
    this.setState({
      name: name
    })
  }

  handleShow_msg( text ) {
    this.setState({
      show_msg: true,
      modal_body: text
    })
  }
  
  handleClose_msg() {
    this.setState({
      show_msg: false
    })
  }

  sendForm = ( e ) => {
    e.preventDefault()

    const { name, phone, isSending } = this.state,
    { btn, data } = this.props

    // Если уже идет отправка, ничего не делаем
    if (isSending) return;

    const main = this,
    baseURL = window.location.protocol + "//" + window.location.hostname
    
    // Устанавливаем состояние отправки
    this.setState({ isSending: true })
    
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'feedback_form',
      'form': btn,
      'name': name,
      'phone': phone,
      'json': JSON.stringify( data )
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if( response.data.result ) {
        main.handleShow_msg( `Сообщение отправлено, наш менеджер свяжется с вами в ближайшее время.` )
        // Очищаем форму после успешной отправки
        this.setState({
          name: ``,
          phone: ``
        })
      } else {
        main.handleShow_msg( `Заполните поля формы` )
      }
    }).catch(error => {
      // Показываем сообщение об ошибке
      main.handleShow_msg( `Произошла ошибка при отправке формы. Пожалуйста, попробуйте еще раз.` )
      console.error('Error sending form:', error)
    }).finally(() => {
      // В любом случае снимаем состояние отправки
      this.setState({ isSending: false })
    })
  }

  render() {

    const { btn, assets_path, width, svg, name: showNameField } = this.props
    const { show_msg, modal_body, isSending, name, phone } = this.state

    return (
      <>
        <Form onSubmit={( e ) => this.sendForm( e )}>
          <div className={styles.form}>
            {showNameField &&
              <div className={styles.form_input_block}>
                <Image src={`/${assets_path}/images/user.svg`} width={14} height={14} alt="имя" />
                <Form.Control
                  className={styles.form_input}
                  name="name"
                  required
                  value={name}
                  onChange={( e ) => this.changeName( e.target.value )}
                  type="text"
                  placeholder="Ваше имя"
                />
              </div>
            }
            <div className={styles.form_input_block}>
              <Image src={`/${assets_path}/images/form_phone.svg`} width={14} height={14} alt="тел." />
              <Form.Control
                className={styles.form_input}
                name="phone"
                required
                value={phone}
                onChange={( e ) => this.changePhone( e.target.value )}
                as={IMaskInput}
                mask="+{7} (000) 000-00-00"
                lazy={true}
                type="text"
                placeholder="+7 (___) ___-__-__"
              />
            </div>
            <GreenButton
              text={isSending ? 'Отправляется...' : btn}
              width={width}
              action={() => {  }}
              svg={svg}
              className={showNameField ? styles.form_button_mhide : styles.form_button}
              disabled={isSending}
              submit={true}
            />
          </div>
          <div className={styles.formb}>
            {showNameField &&
              <GreenButton
                text={isSending ? 'Отправляется...' : btn}
                width={172}
                action={() => {  }}
                svg={svg}
                className={styles.form_button_mshow}
                disabled={isSending}
                submit={true}
              />
            }
            <div className={styles.form_pconf}>
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="17" height="17" rx="8.5" fill="white"/>
                <rect x="4" y="4" width="9" height="9" rx="4.5" fill="#00C775"/>
              </svg>
              <div>Нажимая на кнопку, вы соглашаетесь с <a href="/privacy">политикой конфиденциальности</a></div>
            </div>
          </div>
        </Form>
        <Modal centered show={show_msg} onHide={() => this.handleClose_msg()}>
          <Modal.Header closeButton>
            <Modal.Title>Сообщение</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='modal-text mt-2'>{modal_body}</div>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}

SimleForm.propTypes = {
  btn: PropTypes.string,
  assets_path: PropTypes.string,
  width: PropTypes.string,
  svg: PropTypes.object,
  name: PropTypes.bool,
  data: PropTypes.array
}

SimleForm.defaultProps = {
  btn: `Отправить`,
  assets_path: 'assets',
  width: 170,
  svg: (
    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.09082 7.90998L7.909 1.0918M7.909 1.0918H2.45446M7.909 1.0918V6.54634" strokeLinecap="round"/>
    </svg>
  ),
  name: false,
  data: []
}

export default SimleForm